<template>
  <v-app>
    <v-main class="fill-height">
      <template v-if="loading">
        <v-sheet
          height="90vh"
          class="d-flex justify-center align-center"
        >
          <v-progress-circular
            :size="70"
            :width="7"
            color="teal darken-3"
            indeterminate
          ></v-progress-circular>
        </v-sheet>
      </template>
      <template  v-else>
        <the-meeting-scholarship-container v-if="accessMeeting"/>
        <the-student-scholarship-container v-else/>
      </template>

      <errors-alert/>
    </v-main>
  </v-app>
</template>

<script>
import {mapActions, mapState} from "vuex";

import ErrorsAlert from "../portfolio/Errors/ErrorsAlert.vue";
import axios from "axios";

const TheStudentScholarshipContainer = () => import("./Container/TheStudentScholarshipContainer.vue");

const TheMeetingScholarshipContainer = () => import("./Container/TheMeetingScholarshipContainer.vue");
export default {
  name: "IncreasedScholarship",

  data () {
    return {
      loading: true,
      accessMeeting: false,
    };
  },

  async mounted() {
    await this.getAccessMeeting();
    this.loading = false;
  },

  components: {
    ErrorsAlert,

    TheStudentScholarshipContainer,
    TheMeetingScholarshipContainer,
  },

  computed: {
    ...mapState ({
      roles: state => state.achievement.personal_info.roles,
      protocolAccess: state => state.scholarship_meeting.protocolAccess,
    }),

  },

  methods: {
    ...mapActions({
      getPersonalInfo: 'achievement/getPersonalInfo',
      getProtocolAccess: "scholarship_meeting/getProtocolAccess",
    }),

    async getAccessMeeting() {
      const response = await axios.get("/scholarship/meetings/access_meeting");

      if (response.status === 200) {
        this.accessMeeting = response.data.access_meeting;
      }
    },

  }
}
</script>

<style scoped>
/deep/ .v-application--wrap {
  min-height: calc(100vh - 150px) !important;
}
</style>